import { encodeURI } from "js-base64";
import { useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";

import { useGetPresignedPostQuery } from "../features/api/storage";
import generateFileKey from "../utils/generateFileKey";
import apiErrorToString from "../utils/response";

export default function usePresignedPost(file, prefix = null) {
  const [fileKey, setFileKey] = useState(null);
  const [encodedFileKey, setEncodedFileKey] = useState(null);
  const { data: presignedPostData, isError, error } = useGetPresignedPostQuery({ key: encodedFileKey }, { skip: !encodedFileKey });

  useEffect(() => {
    if (file) {
      let generatedKey = generateFileKey(file.name);
      if (prefix) {
        generatedKey = prefix + generatedKey;
      }
      setFileKey(generatedKey);
      setEncodedFileKey(encodeURI(generatedKey));
    }
    return () => setFileKey(null);
  }, [file, prefix]);

  useEffect(() => {
    if (isError) {
      if (error.status !== 401) {
        Swal.fire({
          title: "Error!",
          text: apiErrorToString(error),
          icon: "error",
        });
      }
    }
  }, [isError, error]);

  return useMemo(
    () => ({
      presignedPostData,
      fileKey,
    }),
    [presignedPostData, fileKey],
  );
}
